export default __webpack_public_path__ + "static/media/btCard.09651435.jpg";